export default __webpack_public_path__ + "static/media/HEPL Website_organized.d8e0a597.pdf";